<template>
    <v-container>
        <v-card class="mt-4" hover @click="gotoBot(index)" style="border-radius: 8px;" v-for="(page,index) in pagesList" :key="page.name">
            <v-layout>
                <v-flex xs2>
            <v-avatar
            :size="60"
            >
                <v-img
                    class="elevation-6 ml-5"
                    :src="page.imageurl"
                ></v-img>
            </v-avatar>
            </v-flex>
            <v-flex xs6 class="mt-1">
                <div class="title font-weight-regular mt-3"> {{page.name}} </div>
            </v-flex>
            <v-flex xs2 class="mt-1">
                <v-btn v-if="!page.isBot" flat round class="mt-2" :color="page ? 'primary' : ''" @click="connectPage(index)">Connect</v-btn>
                <v-btn v-if="page.isBot" disabled flat round class="mt-2">Connected</v-btn>
            </v-flex> 
            </v-layout>
        </v-card>
        <v-card hover class="mt-4" height="90px" style="border-radius: 8px;" href="https://www.facebook.com/pages/creation/" target="_blank">
            <v-layout>
                <v-flex xs5>
                </v-flex>
                <v-flex xs8>
            <div class="headline mt-3"> + Add new page </div>
            </v-flex>
            </v-layout>
        </v-card>       
    </v-container>
</template>

<script>
import axios from 'axios'
import router from '../router'
import store from '../store'
import {db, auth, fn} from '@/plugins/firebase.js';
export default {
    data(){
        return{
           pages:null
        }
    },
    methods:{
        connectPage(index){
            let pageslist = this.pages
             FB.getLoginStatus(function(response) {
                if(response.status == 'connected') {                     
                    FB.api(
                    "/"+pageslist[index].id+"/subscribed_apps?access_token=" +pageslist[index].access_token,
                    'POST',
                    {"subscribed_fields":"messages,messaging_postbacks,messaging_referrals,feed"},
                    function (response) {
                        console.log('Bot created')
                        db.collection("pages").doc(pageslist[index].id)
                        .set({
                                "author": auth.currentUser.uid,
                               // "access_token": pageslist[index].access_token ,
                                "admin_mail": auth.currentUser.email,
                                "subscription": null,
                                "bot_name": pageslist[index].name,
                                "bot_image": pageslist[index].imageurl,
                                "default":null
                            })
                        .then(ref => {  
                           console.log("Page Created")
                           let pageid = pageslist[index].id
                           let userAccessToken = pageslist[index].userAccessToken
                           let access_token = pageslist[index].access_token
                           store.dispatch('awelcomeresponse',{pageid,access_token})
                           store.dispatch('adefaultresponse',{pageid,access_token})
                        //    var addMessage = fn.httpsCallable('webhook')
                        //         addMessage({"pageid": pageid, "userAccessToken": userAccessToken}).then(function(result) {
                        //         // Read result of the Cloud Function.
                        //         console.log(result)
                        //         console.log("Function triggered")
                        //         // ...
                        //         });  
                        //////////////////////////////   
                        let res1 = axios({
                                            method: "get",
                                            url: "https://small-umbra.glitch.me/token",
                                            data: null,
                                            params: {pageid,userAccessToken}
                                        })
                                    .then(response => {
                                        console.log(response)
                                    })
                                    .catch(error => {
                                    console.log(error)
                                    })
                        })
                        store.dispatch('aSelectedPage',pageslist[index].id)                         
                        router.push('/settings/ps/'+pageslist[index].id)                                
                    });
                    }
                else{    
                console.log("unable to get login status") 
                }     
                })
            console.log("connected to new page")                      
        },
        gotoBot(index){
            let pageslist = this.pages
            let pageid = pageslist[index].id
            this.$store.dispatch('aSelectedPage',pageid)
            router.push('/settings/ps/'+pageslist[index].id)
        }
    },
    computed:{
        pagesList(){
            this.pages = this.$store.state.pagesList
            return this.pages
        }
    }    
}
</script>
